/**
 *  @class
 *  @function MegaMenuSidebar
 */
if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.mega-menu-sidebar--button');
      this.content = this.querySelectorAll('.mega-menu-sidebar--content-inner');
      this.shopAllButtons = this.querySelectorAll('.shop_all_button');

      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseover', (event) => {
          this.onHover(event, button, i);
        });
      });

      this.images = this.querySelectorAll('img');

      window.addEventListener('load', () => {
        this.images.forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      });
    }

    onHover(event, button, i) {
      this.content.forEach((content, index) => {
        content.classList.remove('active');

        const shopButton = content.nextElementSibling;

        if (
          shopButton &&
          shopButton.classList.contains('shop_all_button')
        ) {
          shopButton.classList.remove('active');
        }

        if (i === index) {
          content.classList.add('active');

          if (
            shopButton &&
            shopButton.classList.contains('shop_all_button')
          ) {
            shopButton.classList.add('active');
          }
        }
      });

      this.buttons.forEach((btn) => {
        btn.classList.remove('active');
      });

      button.classList.add('active');
    }
  }

  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}

// if (!customElements.get('mega-menu-sidebar')) {
//   class MegaMenuSidebar extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       this.buttons = this.querySelectorAll('.mega-menu-sidebar--button');
//       this.shop_all_buttons = this.querySelectorAll('.shop_all_button');
//       this.content = this.querySelectorAll('.mega-menu-sidebar--content-inner');

//       this.buttons.forEach((button, i) => {
//         button.addEventListener('click', (event) => {
//           this.onClick(event, button, i);
//         });
//       });

//       this.images = this.querySelectorAll('img');

//       window.addEventListener('load', () => {
//         this.images.forEach((image) => {
//           lazySizes.loader.unveil(image);
//         });
//       });
//     }

//    onClick(event, button, i) {

//   this.content.forEach((content, index) => {

//     content.classList.remove('active');

//     const shopButton = content.nextElementSibling;

//     if (shopButton && shopButton.classList.contains('shop_all_button')) {
//       shopButton.classList.remove('active');
//     }

//     if (i === index) {
//       content.classList.add('active');

//       if (shopButton && shopButton.classList.contains('shop_all_button')) {
//         shopButton.classList.add('active');
//       }
//     }
//   });

//   this.buttons.forEach((this_button) => {
//     this_button.classList.remove('active');
//   });

//   button.classList.add('active');
// }
//   }

//   customElements.define('mega-menu-sidebar', MegaMenuSidebar);
// }
